import { useTableSelection } from '../hooks/use-table-selection';
import { RowCounter } from '../table.style';

import { ActionBarTestId } from './action-bar';
import { ActionBarProps } from './action-bar.types';

export function SelectedRowCounter<TData>({ table }: ActionBarProps<TData>) {
  const { selectedCount } = useTableSelection(table);

  return (
    <RowCounter data-testid={ActionBarTestId.selectedCounter}>
      {selectedCount} selected
    </RowCounter>
  );
}
